import { BlockTopText, ContactUsCard } from '@renderer-ui-library/molecules'
import { Grid } from '@renderer-ui-library/mui'
import { BlockWrapper } from '@renderer-ui-library/scaffolding/BlockWrapper/BlockWrapper'
import { BlockProps } from 'blocks/BlockProps'
import React, { useMemo } from 'react'
import { IContactBlockData } from './IContactBlockData'
import { TServerSideContactBlockProps } from './TServerSideContactBlockProps'
import styles from './contactBlockStyles.module.scss'

export const ContactBlock: React.FC<
  BlockProps<IContactBlockData, TServerSideContactBlockProps>
> = React.memo(({ preFetchedBlockProps, data }) => {
  const people = useMemo(
    () =>
      preFetchedBlockProps.people.sort((a, b) =>
        a.firstName.localeCompare(b.firstName)
      ),
    [preFetchedBlockProps.people]
  )

  if (people.length === 0) {
    return null
  }

  return (
    <BlockWrapper blockData={data}>
      {data.topText && (
        <BlockTopText text={data.topText} highlight={data.highlight} />
      )}
      <Grid container columnSpacing={4} rowSpacing={4}>
        {people.map((person) => (
          <Grid
            item
            xs={12}
            md={4}
            key={person.id}
            className={styles.cardWrapper}
          >
            <ContactUsCard salesManager={person} />
          </Grid>
        ))}
      </Grid>
    </BlockWrapper>
  )
})

ContactBlock.displayName = 'ContactBlock'
